import React from "react";
import { brand } from "../config/brands";

export default function PrivacyPolicy() {
  return (
    <div className="p-6 max-w-3xl mx-auto text-gray-800">
      <h1 className="text-3xl font-bold mb-6">Privacy Policy</h1>
      <p className="mb-4">
        At <strong>{brand.displayName}</strong>, we are committed to protecting your privacy. This Privacy Policy
        outlines how we collect, use, disclose, and safeguard your information when you use our
        delivery app. By accessing or using our services, you agree to the terms of this Privacy
        Policy.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">1. Information We Collect</h2>
      <ul className="list-disc pl-6 mb-4">
        <li><strong>Personal Information:</strong> When you create an account, we collect personal information such as your name, email address, phone number, and delivery address.</li>
        <li><strong>Payment Information:</strong> We may collect payment details to process your orders. This information is securely stored and processed by our payment partners.</li>
        <li><strong>Usage Data:</strong> We collect information about how you use our app, including your device information, IP address, and browsing behavior.</li>
        <li><strong>Location Information:</strong> We collect background location data to enable real-time delivery tracking, even when the app is closed or not in use. This is used to ensure accurate and timely deliveries.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">2. How We Use Your Information</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>To provide and maintain our services</li>
        <li>To process transactions and manage your orders</li>
        <li>To communicate with you, including sending updates, promotions, and customer support</li>
        <li>To improve our app and services through data analysis and feedback</li>
        <li>To detect, prevent, and address technical issues and fraud</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">3. Sharing Your Information</h2>
      <p className="mb-4">
        We do not sell or rent your personal information to third parties. We may share your
        information with:
      </p>
      <ul className="list-disc pl-6 mb-4">
        <li><strong>Service Providers:</strong> Third-party companies to facilitate our services, process payments, and analyze data.</li>
        <li><strong>Legal Requirements:</strong> Authorities if required by law or for legal processes.</li>
      </ul>

      <h2 className="text-2xl font-semibold mt-6 mb-2">4. Data Security</h2>
      <p className="mb-4">
        We take the security of your personal information seriously. We implement reasonable
        security measures to protect your data from unauthorized access, alteration, disclosure, or
        destruction. However, no method of transmission over the internet or electronic storage is
        100% secure.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">5. Your Rights</h2>
      <ul className="list-disc pl-6 mb-4">
        <li>Access, correct, or delete your personal information</li>
        <li>Withdraw consent for processing your data</li>
        <li>Opt-out of marketing communications</li>
      </ul>
      <p className="mb-4">
        To exercise your rights, please contact us at <a href="mailto:scoot.app@hotmail.com" className="text-blue-600 underline">scoot.app@hotmail.com</a>.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">6. Changes to This Privacy Policy</h2>
      <p className="mb-4">
        We may update our Privacy Policy from time to time. We will notify you of any changes by
        posting the new Privacy Policy on this page. You are advised to review this Privacy Policy
        periodically for any changes.
      </p>

      <h2 className="text-2xl font-semibold mt-6 mb-2">7. Contact Us</h2>
      <p>
        If you have any questions or concerns about this Privacy Policy, please contact us at
        <a href="mailto:scoot.app@hotmail.com" className="text-blue-600 underline"> scoot.app@hotmail.com</a>.
      </p>

      <p className="mt-6">Thank you for trusting <strong>{brand.displayName}</strong> with your delivery needs!</p>
    </div>
  );
}
